import moment from 'moment';
import { isArray, forOwn, isEmpty } from 'lodash';
import { CONFIGURATIONS_FIELD_NAME, OPERATOR_NAME } from './QueryBuilder/constants';
import uiLabelsPaths from '../../services/uiFieldLabelsDictionary';

const fieldToOperator = {
  c_uuid: OPERATOR_NAME.contains,
  c_uuid_contains: OPERATOR_NAME.contains,
  name: OPERATOR_NAME.contains,
  country_contains: OPERATOR_NAME.contains,
  address: OPERATOR_NAME.contains,
  contact: OPERATOR_NAME.contains,
  details: OPERATOR_NAME.contains,
  user_name: OPERATOR_NAME.contains,
  fw_version: OPERATOR_NAME.contains,
  product_serial_number: OPERATOR_NAME.contains,
  current_firmware_version: OPERATOR_NAME.contains,
  new_firmware_version: OPERATOR_NAME.contains,
  configuration_update_username: OPERATOR_NAME.contains,
  time: OPERATOR_NAME.dateEquals,
  warranty_end: OPERATOR_NAME.dateEquals,
  request_time: OPERATOR_NAME.dateEquals,
  end_time: OPERATOR_NAME.dateEquals,
  f_status: OPERATOR_NAME.anyOf,
  customer_id: OPERATOR_NAME.equals,
};

export const nodeConfigurationsValues = {
  config_node_name: 'Node Name',
  parameter_name: 'Parameter Name',
  parameter_value: 'Value',
};

export const TABS = {
  CHARGER: 'charger',
  CONFIGURATION: 'configuration',
};

export const emptyFilter = {
  operator: 'AND',
  conditions: [],
};

export const getConfigurationPayload = ({ operator, conditions }) => {
  const paramFilters = conditions.map((condition) => {
    if (condition.conditions) {
      const nodeNameCondition = condition.conditions.find(({ field }) => field === CONFIGURATIONS_FIELD_NAME.nodeName);
      const nestedCondition = condition.conditions.filter(({ field }) => field !== CONFIGURATIONS_FIELD_NAME.nodeName);

      const updatedConditions = [
        {
          operator: 'NESTED',
          path: 'live_parameters',
          searchCondition: {
            operator: 'AND',
            conditions: nestedCondition,
          },
        },
      ];

      if (nodeNameCondition) {
        updatedConditions.push(nodeNameCondition);
      }

      return {
        operator: condition.operator,
        conditions: updatedConditions,
      };
    }

    return condition;
  });

  return {
    searchOperator: operator,
    paramFilters,
  };
};

export const fillChargersFilter = (simpleFilter, advancedFilter) => {
  if (isArray(simpleFilter)) {
    simpleFilter = simpleFilter.reduce((acc, { id, value }) => {
      acc[id] = value;

      return acc;
    }, {});
  }

  forOwn(simpleFilter, (value, field) => {
    const operator = fieldToOperator[field] || OPERATOR_NAME.equals;

    if (['time', 'configuration_update_ts'].includes(field)) {
      value = moment.utc(value, 'MM/DD/YYYY').valueOf();
    } else if (field === 'warranty_end' || field === 'request_time' || field === 'end_time') {
      value = Number(value);
    }

    if (field === 'selectedFwVer' && value !== 'No FW Version') {
      advancedFilter.conditions.push({ field: 'fw_version', operator: OPERATOR_NAME.equals, value });
    } else if (field === 'selectedFwVer' && value === 'No FW Version') {
      advancedFilter.conditions.push({ field: 'fw_version', operator: OPERATOR_NAME.empty });
    } else if (field === 'customerId') {
      advancedFilter.conditions.push({ field: 'customer_id', operator, value });
    } else if (field === uiLabelsPaths.p_type) {
      advancedFilter.conditions.push({
        field: uiLabelsPaths.p_type,
        operator: Array.isArray(value) ? OPERATOR_NAME.anyOf : OPERATOR_NAME.equals,
        value: isEmpty(value) ? [] : value,
      });
    } else {
      advancedFilter.conditions.push({ field, operator, value });
    }
  });
};
